import React from "react";
import CardElement from "./CardElement";

import { MicrophoneIcon } from "@heroicons/react/24/solid";
import { ComputerDesktopIcon } from "@heroicons/react/24/solid";
import { UserGroupIcon } from "@heroicons/react/24/solid";
import { VideoCameraIcon } from "@heroicons/react/24/solid";
import { SpeakerWaveIcon } from "@heroicons/react/24/solid";
import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";

function Cards() {
  return (
    <div class="grid md:grid-cols-3 sm:grid-cols-2 gap-4  sm:mx-8 xl:mx-10 my-10">
      <CardElement
        title="Sound and Lighting"
        icon={<MicrophoneIcon />}
        paragraph="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis neque voluptatibus tempora qui blanditiis similique ex maxime doloremque sunt expedita rerum quia autem, natus saepe porro facere consequatur ipsum placeat."
      />
      <CardElement
        title="Projector & Screen Rentals"
        icon={<ComputerDesktopIcon />}
        paragraph="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis neque voluptatibus tempora qui blanditiis similique ex maxime doloremque sunt expedita rerum quia autem, natus saepe porro facere consequatur ipsum placeat."
      />
      <CardElement
        title="Hire AV Labor Crews"
        icon={<UserGroupIcon />}
        paragraph="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis neque voluptatibus tempora qui blanditiis similique ex maxime doloremque sunt expedita rerum quia autem, natus saepe porro facere consequatur ipsum placeat."
      />
      <CardElement
        title="Live Streams & Webinars"
        icon={<VideoCameraIcon />}
        paragraph="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis neque voluptatibus tempora qui blanditiis similique ex maxime doloremque sunt expedita rerum quia autem, natus saepe porro facere consequatur ipsum placeat."
      />
      <CardElement
        title="PA Systems"
        icon={<SpeakerWaveIcon />}
        paragraph="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis neque voluptatibus tempora qui blanditiis similique ex maxime doloremque sunt expedita rerum quia autem, natus saepe porro facere consequatur ipsum placeat."
      />
      <CardElement
        title="Stage Rentals & Set Pieces"
        icon={<ClipboardDocumentCheckIcon />}
        paragraph="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis neque voluptatibus tempora qui blanditiis similique ex maxime doloremque sunt expedita rerum quia autem, natus saepe porro facere consequatur ipsum placeat."
      />
    </div>
  );
}

export default Cards;
